import i18n from 'src/i18n.js';

export const proxiesTabs = () => [
    { id: 'proxiesTab1', label: i18n.t('admin.proxies.peopleIProxy') },
    { id: 'proxiesTab2', label: i18n.t('admin.proxies.proxyForMe') },
];
